export class CustomLoading {
  loading;
  Loading;

  constructor(loading) {
    this.Loading = loading;
  }

  showLoading(vm, tip = '加载中', target = '.content-wrap') {
    if (this.loading && this.loading.close) {
      this.loading.close();
      this.loading = null;
    }

    this.loading = this.Loading.service({
      target: target,
      lock: true,
      text: vm.$t('lang.' + tip),
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.5)'
    });
  }

  hideLoading() {
    if (this.loading && this.loading.close) {
      this.loading.close();
      this.loading = null;
    }
  }
}

